/* global Word */
import { ParagraphBuilder } from './ParagraphBuilder';

/**
 * ContentControlBuilder — helpers for inserting content controls.
 */
export class ContentControlBuilder {
  public static insertGraphPlaceholder(para: Word.Paragraph, placeholderText?: string): Word.ContentControl {
    para.alignment = Word.Alignment.left;
    ParagraphBuilder.clearSpacing(para);

    const cc = para.insertContentControl(Word.ContentControlType.richText);
    cc.placeholderText = placeholderText || 'Paste your graph here';
    cc.cannotDelete = false;
    cc.cannotEdit = false;
    cc.appearance = Word.ContentControlAppearance.hidden;
    cc.tag = 'graph_box_container';
    cc.title = '';
    return cc;
  }

  public static insertTablePlaceholder(para: Word.Paragraph, placeholderText?: string): Word.ContentControl {
    para.alignment = Word.Alignment.left;
    ParagraphBuilder.clearSpacing(para);

    const cc = para.insertContentControl(Word.ContentControlType.richText);
    cc.placeholderText = placeholderText || 'Paste your Table/Image here';
    cc.cannotDelete = false;
    cc.cannotEdit = false;
    cc.appearance = Word.ContentControlAppearance.hidden;
    cc.tag = 'table_box_container';
    cc.title = '';
    return cc;
  }
}

